module.exports = __webpack_public_path__ + "img/bg-img-1.21c7b9de.png";